module.exports = __webpack_public_path__ + "img/20201213_133248.c92dd873.jpg";